"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartDate = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
tslib_1.__exportStar(require("./scheduling"), exports);
var getStartDate = function (event, format) {
    try {
        if (event.scheduling.config.startDate) {
            var startDate = new Date(event.scheduling.config.startDate);
            return moment_1.default(startDate).format(format);
        }
    }
    catch (e) {
        return;
    }
};
exports.getStartDate = getStartDate;
//# sourceMappingURL=helpers.js.map